import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SignatureAuditLog from './signature-audit-log';
import SignatureAuditLogDetail from './signature-audit-log-detail';
import SignatureAuditLogUpdate from './signature-audit-log-update';
import SignatureAuditLogDeleteDialog from './signature-audit-log-delete-dialog';

const SignatureAuditLogRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SignatureAuditLog />} />
    <Route path="new" element={<SignatureAuditLogUpdate />} />
    <Route path=":id">
      <Route index element={<SignatureAuditLogDetail />} />
      <Route path="edit" element={<SignatureAuditLogUpdate />} />
      <Route path="delete" element={<SignatureAuditLogDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SignatureAuditLogRoutes;
